<div class="border border-secondary rounded">
    <div class="card-header text-bg-secondary p-3">
        <h3 class="h5 fw-bold">{{ treeType() }}</h3>
    </div>
    <div class="p-4">
        <div class="d-flex border border-secondary">
            <la-tree-node [node]="displayTree()" [treeType]="treeType()" />
        </div>
    </div>
</div>
